// extracted by mini-css-extract-plugin
module.exports = {"header":"header-2IHCU","created":"created-3WPGT"};